import styled from 'styled-components';

export const SongEntryStyled = styled.li`

  position: relative;
  padding: 1rem;
  border-bottom: .5px solid rgb(10, 10, 10);
  list-style: none;
  user-select: none;
  cursor: pointer;

  p {
    font-size: 2rem;
    text-align: start;
}
`